'use strict';

var items = {
  a: 0,
  b: '-4px',
  c: '-2px',
  d: '-4px',
  e: '-4px',
  f: '-4px',
  g: '-2px',
  h: '-4px',
  i: '-4px',
  j: '5px',
  k: '-4px',
  l: '-4px',
  m: '-2px',
  n: '-4px',
  o: '-2px',
  p: '-4px',
  q: '-2px',
  r: '-4px',
  s: '-2px',
  t: '-1px',
  u: '-4px',
  v: 0,
  w: 0,
  x: 0,
  y: 0,
  z: '-2px'
};


(function ($) {
  Drupal.behaviors.paddinglazer = {
    attach: function () {
      $('h1').each(function () {
        var $heading = $(this);
        var headingText = $heading.text();
        var firstLetter = headingText.charAt(0);
        if (!isNaN(firstLetter)) {
          $heading.css('margin-left', '-1px');
        }
        firstLetter = firstLetter.toLowerCase();
        if (items[firstLetter] !== 'undefined') {
          $heading.css('margin-left', items[firstLetter]);
        }

      });
    }
  };

})(jQuery);
